import React, { FunctionComponent, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { StackScreenProps } from '@react-navigation/stack'
import { Page, LeftButtonBack } from '../../components/Page'
import { CartographyZonesActions } from '../../redux/cartographyZones/actions'

import { CartographyZonesMap } from '../../components/CartographyZonesMap'
import { ActionViewParamsType } from '../../navigation/Routes'

export const CartographieZone: FunctionComponent<StackScreenProps<ActionViewParamsType, 'CartographieZone'>> = ({ route }) => {
  const title = route.params.titre as string

  const zoneId = route.params.id as number

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(CartographyZonesActions.loadCartographyZones(zoneId))
  }, [])

  return (
    <Page left={<LeftButtonBack />} title={title}>
      <CartographyZonesMap zoneId={zoneId} />
    </Page>
  )
}
